import React, { useMemo } from 'react';

export interface ConfettiProps {
  active: boolean;
  colors: string[];
  count?: number;
}

export const Confetti: React.FC<ConfettiProps> = ({ active, colors, count = 60 }) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        color: colors[i % colors.length],
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        dur: 1.8 + Math.random() * 1.4,
        rot: Math.random() * 360,
        drift: (Math.random() - 0.5) * 120,
        shape: Math.random() > 0.5 ? 'rect' : 'circ',
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 10,
      })),
    [count, colors]
  );

  if (!active) return null;

  return (
    <>
      <div className="pointer-events-none absolute inset-0 z-[100] overflow-hidden">
        {pieces.map((p) => (
          <div
            key={p.id}
            style={{
              position: 'absolute',
              top: -20,
              left: `${p.left}%`,
              width: p.shape === 'circ' ? p.w : p.w,
              height: p.shape === 'circ' ? p.w : p.h,
              borderRadius: p.shape === 'circ' ? '50%' : 2,
              background: p.color,
              animation: `chanceyConfetti ${p.dur}s cubic-bezier(.3,.7,.4,1) ${p.delay}s forwards`,
              ['--drift' as string]: `${p.drift}px`,
              ['--rot' as string]: `${p.rot}deg`,
            }}
          />
        ))}
      </div>
      <style>{`
        @keyframes chanceyConfetti {
          0% { transform: translate(0, -20px) rotate(0deg); opacity: 1; }
          100% { transform: translate(var(--drift), 900px) rotate(var(--rot)); opacity: 0.9; }
        }
      `}</style>
    </>
  );
};
